interface MovableRect {
    x1: number;
    x2: number;
    y1: number;
    y2: number;
    width: number;
    height: number;
}

const overlap = (a: MovableRect, b: MovableRect) => {
    return Math.abs(a.x1 - b.x1) * 2 < a.width + b.width && Math.abs(a.y1 - b.y1) * 2 < a.height + b.height;
};

const toMovableRect = (rect: DOMRect, translate: [number, number]) => {
    return {
        x1: rect.left + translate[0],
        x2: rect.right + translate[0],
        y1: rect.top + translate[1],
        y2: rect.bottom + translate[1],
        width: rect.width,
        height: rect.height
    };
};

const recomputeTranslates = (boundingRectangles: any[]) => {
    const translates: [number, number][] = boundingRectangles.map(() => [0, 0]);
    const copy = boundingRectangles.map((d) => ({ ...d }));
    let move = 1;
    while (move > 0) {
        move = 0;
        copy.forEach((d, i) => {
            let a = toMovableRect(d, translates[i]);
            copy.forEach((din, j) => {
                if (i !== j) {
                    const b = toMovableRect(din, translates[j]);
                    if (overlap(a, b)) {
                        const dx = (Math.max(0, a.x2 - b.x1) + Math.min(0, a.x1 - b.x2)) * 0.01;
                        const dy = (Math.max(0, a.y2 - b.y1) + Math.min(0, a.y1 - b.y2)) * 0.02;
                        translates[i] = [translates[i][0] + dx, translates[i][1] + dy];
                        translates[j] = [translates[j][0] - dx, translates[j][1] - dy];
                        a = toMovableRect(d, translates[i]);
                        move += Math.abs(dx) + Math.abs(dy);
                    }
                }
            });
        });
    }
    return translates;
};

export default recomputeTranslates;
